<script>
	import { uiText } from "../lib/uiText.js";
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();
	export let lang = "bg";
	let ui = uiText(lang);
	$: lang, (ui = uiText(lang));
	export let hints;
	export let usedHints = false;

	// on:click={() => dispatch('input', input)}

	function openHint(n) {
		let time;
		// console.log("hint used: " + n);
		if (hints[n].constructor === String) {
			time = parseInt(
				hints[n].substring(
					hints[n].lastIndexOf("(") + 1,
					hints[n].lastIndexOf(")"),
				),
			);
		} else {
			time = parseInt(hints[n].time);
		}

		if (time == 0) {
			time = true;
		}

		dispatch("usingHint", { [n]: time });
	}

	function checkSlider(slid) {
		let hint = document.getElementById("hint_" + slid);
		let slider = document.getElementById("hintslider_" + slid);

		if (slider.value > 95) {
			if (confirm(ui.game.aside.hint_confirmation)) {
				hint.open = true;
				slider.value = 100;
				slider.disabled = true;
				// localUsedHints[slid - 1] = true;

				// console.log('You pressed OK!');
				openHint(slid);
			} else {
				// console.log('You pressed Cancel!');
				hint.open = false;
				slider.value = 1;
			}
		} else {
			hint.open = false;
			slider.value = 1;
			// openHint();
		}
	}

	function preventDefault(event) {
		event.preventDefault();
	}
</script>

{#if hints.length > 0}
	<div class="mx-auto my-6 text-center max-w-prose">
		<p>{ui.game.aside.has_hints}</p>
		<p>{ui.game.aside.has_hints_description}</p>
	</div>
	{#each hints as hint, i}
		{#if hint.constructor === String}
			<!-- OLD HINT TYPE -->
			<details
				id={"hint_" + i}
				on:click={preventDefault}
				open={usedHints === undefined ? false : usedHints[i]}
				class="mb-8 text-center"
			>
				<summary>
					<input
						type="range"
						min="1"
						max="100"
						value={usedHints === undefined ? 0 : usedHints[i] ? 100 : 0}
						class="slider"
						id={"hintslider_" + i}
						on:change={() => checkSlider(i)}
						disabled={usedHints === undefined ? false : usedHints[i]}
					/>
					<!-- remove this -->
					<!-- <p>?: {usedHints[i]}</p> -->
					<!-- remove this -->
					<span class="max-w-prose">
						<!-- {i + 1} : - BRING BACK AFTER INGRAM -->
						{hint.substring(hint.lastIndexOf("~") + 1, hint.lastIndexOf("^"))} [-{hint.substring(
							hint.lastIndexOf("(") + 1,
							hint.lastIndexOf(")"),
						)}
						{hint.substring(hint.lastIndexOf("(") + 1, hint.lastIndexOf(")")) ==
						1
							? ui.conclusion.point
							: ui.conclusion.points}]
						<br />
						{#if usedHints === undefined ? false : !usedHints[i]}
							{ui.game.aside.slide_to_unlock}
						{/if}
					</span>
				</summary>
				{#if usedHints === undefined ? false : usedHints[i]}
					{hint.substring(hint.lastIndexOf(")") + 1)}
				{/if}
			</details>
		{:else}
			<!-- NEW HINT TYPE -->
			<details
				id={"hint_" + i}
				on:click={preventDefault}
				open={usedHints === undefined ? false : usedHints[i]}
				class="mb-8 text-center"
			>
				<summary>
					<input
						type="range"
						min="1"
						max="100"
						value={usedHints === undefined ? 0 : usedHints[i] ? 100 : 0}
						class="slider"
						id={"hintslider_" + i}
						on:change={() => checkSlider(i)}
						disabled={usedHints === undefined ? false : usedHints[i]}
					/>
					<span class="max-w-prose">
						<!-- {i + 1} : - BRING BACK AFTER INGRAM -->
						{@html hint.guide} [-{hint.time}
						{hint.time == 1 ? ui.conclusion.point : ui.conclusion.points}]
						<br />
						{#if usedHints === undefined ? false : !usedHints[i]}
							{ui.game.aside.slide_to_unlock}
						{/if}
					</span>
				</summary>

				{#if usedHints === undefined ? false : usedHints[i]}
					{@html hint.content}
				{/if}
			</details>
		{/if}
	{/each}
	<!-- {:else} -->
	<!-- <p>Тази загадка няма хинтуе</p> -->
{/if}

<!-- {:else} -->
<!-- {#each hints as hint, i}
        <li>{i + 1}: {hint}</li>
        OLD HINT
    {/each} -->
<!-- {/if} -->

<!-- {hints} -->
<style>
	/*details >*/
	details > summary {
		list-style: none;
	}

	details > summary::marker {
		display: none;
	} /* Latest Chrome, Edge, Firefox */
	details > summary::-webkit-details-marker /* Safari */ {
		display: none;
	}

	input[type="range"] {
		pointer-events: none;
		-webkit-appearance: none;
		appearance: none;
	}

	input[type="range"]::-webkit-slider-thumb {
		/*Webkit Browsers like Chrome and Safari*/
		pointer-events: auto;
	}
	input[type="range"]::-moz-range-thumb {
		/*Firefox*/
		pointer-events: auto;
	}
	input[type="range"]::-ms-thumb {
		/*Internet Explorer*/
		pointer-events: auto;
	}

	details[open] summary input::-webkit-slider-thumb,
	details[open] summary input::-moz-range-thumb {
		pointer-events: none;
	}

	.slider {
		appearance: none;
		-webkit-appearance: none;
		margin: 10px;
		padding: 0;
		background-image: url("/img/svg/slider-background.svg");
		animation: slider-hint 2s linear infinite paused;
		background-color: #093986;
		background-position: center;
		background-size: contain;
		width: -webkit-fill-available;
		max-width: min(1200px, 80vw);
		display: block;
		margin-inline: auto;
	}
	.slider:not(:disabled):hover,
	.slider:not(:disabled):focus {
		animation-play-state: running;
	}
	.slider:after {
		content: "\f023"; /*key -\f084;*/
		color: #05204a;
		font-family: "Font Awesome 6 Pro", "Font Awesome 6 Free";
		font-weight: 900;
		font-size: 20px;
		line-height: 40px;
		display: block;
		padding: 0 10px;
		background-color: #47e4bf;
	}
	.slider:disabled:after {
		content: "\f13e"; /*key -\f084; padlock-old -\f09c*/
	}
	.slider::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;
		width: 20px;
		height: 20px;
		border: 10px solid #47e4bf;
		box-sizing: content-box;
		background-image: url("/img/svg/key-solid.svg");
		background-color: #47e4bf;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;
		cursor: pointer;
	}

	.slider::-moz-range-thumb {
		-webkit-appearance: none;
		appearance: none;
		width: 20px;
		height: 20px;
		border: 10px solid #47e4bf;
		box-sizing: content-box;
		background-image: url("/img/svg/key-solid.svg");
		background-color: #47e4bf;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;
		cursor: pointer;
	}
	@keyframes slider-hint {
		from {
			background-position: 0 0;
		}
		to {
			background-position: 40px 0;
		}
	}
</style>
